import { fetcher } from "helpers/fetcher";

import { TGetJobListingFacilityReq, TGetJobListingFacilityRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getJobListingFacility = async (
  params?: TGetJobListingFacilityReq
) => {
  return await fetcher<
    TGetJobListingFacilityRes,
    TGetJobListingFacilityReq["data"]
  >(ENDPOINT.CORPORATION.GET_JOB_LISTING_FACILITY, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_JOB_LISTING_FACILITY.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
    },
  });
};

export const queryGetJobListingFacility = async (
  params?: TGetJobListingFacilityReq
) => {
  return (await getJobListingFacility(params)).data;
};

queryGetJobListingFacility._key = (
  params?: TGetJobListingFacilityReq,
  key?: number
) => [ENDPOINT.CORPORATION.GET_JOB_LISTING_FACILITY.url, params, key];
